import React from "react";
import { useTranslation } from "react-i18next";
import TimezoneSelect, { allTimezones, type ITimezone } from "react-timezone-select";

import { useAppDispatch } from "../../redux/hooks";
import { dispatchTimeZone } from "../../redux/actions";
import { valueFromLocalStorage } from "../../utils/helpers";

const SelectTimeZone = (): JSX.Element => {
  const { t } = useTranslation();

  const dispatch: Dispatch = useAppDispatch();

  const [selectedTimezone, setSelectedTimezone] = React.useState<ITimezone>(
    valueFromLocalStorage("selectedTimezone")
      ? JSON.parse(valueFromLocalStorage("selectedTimezone") as string)
      : Intl.DateTimeFormat().resolvedOptions().timeZone
  );
  // console.info("selectedTimezone:", selectedTimezone);

  React.useEffect(() => {
    if (selectedTimezone) {
      // console.info("selectedTimezone:", selectedTimezone);
      const timeZoneValueToDispatch: string =
        typeof selectedTimezone === "string" ? selectedTimezone : selectedTimezone?.value;
      // console.info("timeZoneValueToDispatch:", timeZoneValueToDispatch);
      localStorage.setItem("selectedTimezone", JSON.stringify(timeZoneValueToDispatch));
      dispatch(dispatchTimeZone(timeZoneValueToDispatch));
    }
  }, [dispatch, selectedTimezone]);

  return (
    <React.Fragment>
      <div className="small">
        <label style={{ fontSize: "0.9rem" }}>{t("TimeZone in the Header")}</label>
        <TimezoneSelect
          placeholder={t("Wybierz strefę czasową")}
          isSearchable={true}
          isClearable={false}
          labelStyle="abbrev"
          value={selectedTimezone}
          onChange={setSelectedTimezone}
          // displayValue="GMT"
          displayValue="UTC"
          timezones={{
            ...allTimezones,
            "America/Detroit": "Eastern Time (Miami)",
          }}
        />
      </div>
    </React.Fragment>
  );
};

export default SelectTimeZone;
